module.exports = __webpack_public_path__ + "static/img/banner.0cc04f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/actualmeasurement/banner.png
// module id = nPjY
// module chunks = 12